export const STAGE_STATUS = [
  {code: 'pending', text: '待安排', color: 'gray'},
  {code: 'scheduled', text: '待确认', color: 'yellow'},
  {code: 'confirmed', text: '已确认', color: 'blue'},
  {code: 'completed', text: '已完成', color: 'primary'},
  {code: 'passed', text: '已通过', color: 'green'},
  {code: 'failed', text: '未通过', color: 'red'}
]

export const REVIEW_STATUS = [
  {code: 'submit', text: '未提交', color: 'gray'},
  {code: 'pending_review', text: '待复审', color: 'yellow'},
  {code: 'approved', text: '审核通过', color: 'green'},
  {code: 'rejected', text: '审核不通过', color: 'red'}
]

export const OFFER_STATUS = [
  {code: 'pending', text: '待发Offer', color: 'gray'},
  {code: 'sent', text: '已发Offer', color: 'blue'},
  {code: 'accepted', text: '接受Offer', color: 'green'},
  {code: 'rejected', text: '拒绝Offer', color: 'rose'}
]

export const GRADES = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C']

export const DEMO_SCORE_OPTIONS = [0, 1, 2, 3, 3.5, 4, 4.5, 5]

export const DEMO_SCORE_CRITERIA = [
  {key: 'appearance', label: '形象'},
  {key: 'studentReaction', label: '对学生表现反应'},
  {key: 'facialExpression', label: '面部表情'},
  {key: 'voiceEnergy', label: '声音活力'},
  {key: 'propsTpr', label: '教具/TPR'},
  {key: 'classroomMgmt', label: '课堂管理'},
  {key: 'interaction', label: '互动引导'},
  {key: 'contentClarity', label: '教学内容清晰度'},
  {key: 'timeControl', label: '时间把控'}
]

export const NO_REFERRER = '__none__'

export function findStatus (list, code, defaultCode) {
  let key = code || defaultCode
  for (let i = 0; i < list.length; i++) {
    if (list[i].code === key) {
      return list[i]
    }
  }
  return {code: key, text: key || '', color: 'gray'}
}

export function tchName (row) {
  if (!row) {
    return ''
  }
  if (row.fullName) {
    return row.fullName
  }
  return ((row.firstName || '') + ' ' + (row.lastName || '')).trim()
}

export function parseJson (val, fallback) {
  if (val === null || val === undefined || val === '') {
    return fallback
  }
  if (typeof val !== 'string') {
    return val
  }
  try {
    let parsed = JSON.parse(val)
    return parsed === null ? fallback : parsed
  } catch (e) {
    return fallback
  }
}

export function emptyScores () {
  let scores = {}
  DEMO_SCORE_CRITERIA.forEach(function (c) {
    scores[c.key] = 0
  })
  return scores
}

export function shortTime (val) {
  if (!val) {
    return ''
  }
  return String(val).substring(0, 16)
}



// WEBPACK FOOTER //
// ./src/components/teacher/recruit/recruitConst.js